import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/app/router/routes/routes';
import createMixPanelTrack from '@/app/router/guards/mixpanel';
import {
  isSignedIn,
  hasAuthActionNewPassword,
  hasAuthActionConfirmEmail,
  isAdminUser,
} from '@/app/router/guards/auth';
import { hasAppSubscription, hasAppPermission } from '@/app/router/guards/account';
import { hasActiveFund } from '@/app/router/guards/fund';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  await isSignedIn(to, from, next);
});

router.beforeResolve(async (to, from, next) => {
  hasAppPermission(to, from, next);
});

router.beforeResolve(async (to, from, next) => {
  hasAppSubscription(to, from, next);
});

router.beforeResolve(async (to, from, next) => {
  hasActiveFund(to, from, next);
});


router.beforeResolve(async (to, from, next) => {
  hasAuthActionNewPassword(to, from, next);
  hasAuthActionConfirmEmail(to, from, next);
});

router.beforeResolve(async (to, from, next) => {
  await isAdminUser(to, from, next);
});


router.afterEach((to) => {
  createMixPanelTrack(router, to);
});

export default router;
